var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"py-4 fs-2"},[_vm._v(" "+_vm._s(_vm.$t("modal-paying-status-waiting-body-text-1"))),_c('br'),_vm._v(" "+_vm._s(_vm.$t("modal-paying-status-waiting-body-text-2"))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }